import logoInvoice from 'assets/img/logos/LOGO-BOSPHORE.png';
import IconButton from 'components/common/IconButton';
import React, { useEffect, useState, useRef, forwardRef, useCallback } from 'react';
import { Card, Col, Row, Table } from 'react-bootstrap';
import SimpleBar from 'simplebar-react';
import { FaPhoneAlt } from 'react-icons/fa';
import { HiDocumentText } from 'react-icons/hi';
import { MdOutlineAlternateEmail } from 'react-icons/md';
import { useParams, useSearchParams } from 'react-router-dom';
import { getMagasins, getFacture, getDetailsFacture } from 'data/factures';
import { useReactToPrint } from 'react-to-print';
import { FaUserTie } from 'react-icons/fa6';
import { FaMapMarkerAlt } from 'react-icons/fa';

const Invoice = () => {
  const { idFacture } = useParams();
  const [searchParams] = useSearchParams();
  const magasin = searchParams.get('magasin');
  const [magasinData, setMagasinData] = useState(null);
  const [facture, setFacture] = useState(null);
  const [details, setDetails] = useState([]);
  const componentRef = useRef();
  const printRef = useRef();
  // const handlePrint = useReactToPrint({
  //   content: () => {
  //     if (!printRef.current) {
  //       console.warn('Ref is still null at print time');
  //     }
  //     return printRef.current;
  //   },
  //   removeAfterPrint: true,
  // });

  // const handlePrint = () => {
  //   if (!componentRef.current) return;

  //   const printContent = componentRef.current.innerHTML;
  //   const printWindow = window.open('', '', 'width=1200,height=800');

  //   if (!printWindow) return;

  //   printWindow.document.write('<html><head><title>Invoice</title></head><body></body></html>');
  //   printWindow.document.close();

  //   const head = printWindow.document.head;
  //   const body = printWindow.document.body;

  //   const styleSheets = Array.from(document.head.querySelectorAll('link[rel="stylesheet"], style'));
  //   let loadedCount = 0;

  //   const onLoadCheck = () => {
  //     loadedCount++;
  //     if (loadedCount === styleSheets.length) {
  //       body.innerHTML = printContent;
  //       printWindow.focus();
  //       // printWindow.print();
  //       // printWindow.close();
  //     }
  //   };

  //   styleSheets.forEach(node => {
  //     const clone = node.cloneNode(true);

  //     if (clone.tagName === 'LINK') {
  //       clone.onload = onLoadCheck;
  //       clone.onerror = onLoadCheck;
  //     } else {
  //       onLoadCheck();
  //     }

  //     head.appendChild(clone);
  //   });

  //   // Fallback in case no styles found
  //   if (styleSheets.length === 0) {
  //     body.innerHTML = printContent;
  //     printWindow.focus();
  //     // printWindow.print();
  //     // printWindow.close();
  //   }
  // };

  const handlePrint = () => {
    if (!componentRef.current) return;

    const printContent = componentRef.current.innerHTML;
    const printWindow = window.open('', '', 'width=1200,height=800');

    if (!printWindow) return;

    printWindow.document.write('<html><head><title>Invoice</title></head><body></body></html>');
    printWindow.document.close();

    const head = printWindow.document.head;
    head.insertAdjacentHTML(
      'beforeend',
      `<style>
        @media print {
          * {
            -webkit-print-color-adjust: exact !important;
            print-color-adjust: exact !important;
          }
          .bg-primary {
            background-color: #2c7be5 !important;
            color: white !important;
          }
          .table thead th {
            background-color: #2c7be5 !important;
            color: white !important;
          }
        }
      </style>`
    );
    const body = printWindow.document.body;

    // Copy stylesheets
    const styleSheets = Array.from(document.head.querySelectorAll('link[rel="stylesheet"], style'));
    let loadedCount = 0;

    const onLoadCheck = () => {
      loadedCount++;
      if (loadedCount === styleSheets.length) {
        body.innerHTML = printContent;
        printWindow.focus();
        // printWindow.print();
        // printWindow.close();
      }
    };

    styleSheets.forEach(node => {
      const clone = node.cloneNode(true);

      if (clone.tagName === 'LINK') {
        clone.onload = onLoadCheck;
        clone.onerror = onLoadCheck;
      } else {
        // inline <style> is instantly available
        onLoadCheck();
      }

      head.appendChild(clone);
    });

    // Fallback: If no styles to wait on
    if (styleSheets.length === 0) {
      body.innerHTML = printContent;
      printWindow.focus();
      // printWindow.print();
      // printWindow.close();
    }
  };

  useEffect(() => {
    const fetchAll = async () => {
      try {
        const [magasinDatas, factureData, detailsFacture] = await Promise.all([
          getMagasins({ magasin }),
          getFacture({ nfact: idFacture.replaceAll('-', '/'), magasin }),
          getDetailsFacture({ nfact: idFacture.replaceAll('-', '/'), magasin }),
        ]);
        setMagasinData(magasinDatas);
        setFacture(factureData);
        setDetails(detailsFacture);
        console.log('magasinDatas', magasinDatas);
        console.log('factureData', factureData);
        console.log('detailsFacture', detailsFacture);
      } catch (error) {
        // handle error if needed
        console.error(error);
      }
      console.log(idFacture.replaceAll('-', '/'), magasin);
    };
    fetchAll();
  }, [idFacture, magasin]);

  return (
    <>
      <Card className="mb-3">
        <Card.Body>
          <Row className="justify-content-between align-items-center">
            <Col md>
              <h5 className="mb-2 mb-md-0">
                Facture : {idFacture && idFacture.replaceAll('-', '/')}
              </h5>
            </Col>
            <Col xs="auto">
              <IconButton
                variant="falcon-default"
                size="sm"
                icon="arrow-down"
                className="me-1 mb-2 mb-sm-0"
                iconClassName="me-1"
              >
                Télécharger (.pdf)
              </IconButton>
              <IconButton
                variant="falcon-default"
                size="sm"
                icon="print"
                iconClassName="me-1"
                className="me-1 mb-2 mb-sm-0"
                onClick={() => {
                  if (!printRef.current) {
                    console.warn('Printable ref is null!');
                    return;
                  }
                  handlePrint();
                }}
              >
                Imprimer
              </IconButton>
            </Col>
          </Row>
        </Card.Body>
      </Card>
      <div ref={componentRef}>
        <Card>
          <Card.Body>
            <Row className="align-items-center text-center mb-3">
              <Col sm={4} className="text-sm-start" style={{ minWidth: '300px' }}>
                <div
                  className="d-flex align-items-center"
                  style={{ borderRight: '1px solid #000000', paddingLeft: '10px' }}
                >
                  <img src={logoInvoice} alt="invoice" width={80} />
                  <h5 className="ms-3 mt-2">{magasinData && magasinData[0].nommagasin}</h5>
                </div>
              </Col>
              <Col className="text-sm-start mt-3 mt-sm-0">
                {/* <h2 className="mb-3">FACTURE</h2> */}
                {magasinData && (
                  <>
                    <h5> Adresse : {magasinData[0].adresse}</h5>
                    <div className="d-flex">
                      <h5 className="mb-0 me-2">
                        <FaPhoneAlt className="me-2 fs-9" />
                        {magasinData[0].tel}
                      </h5>

                      <h5 className="mb-2">
                        <MdOutlineAlternateEmail className="me-2" />
                        {magasinData[0].email.charAt(0).toUpperCase() +
                          magasinData[0].email.slice(1).toLowerCase()}
                      </h5>
                    </div>
                    <h5 className="mb-0">Matricule Fiscale : {magasinData[0].matriculeFiscale}</h5>
                  </>
                )}
              </Col>
              <Col xs={12}>
                <hr />
              </Col>
            </Row>
            <Row className="align-items-center" style={{ height: '100%' }}>
              <Col>
                <div style={{ display: 'flex', justifyContent: 'flex-start' }}>
                  <h6 className="text-top" style={{ marginTop: 0 }}>
                    Date: SS
                    {facture &&
                      new Date(facture[0].date).toLocaleDateString('fr-FR', {
                        day: '2-digit',
                        month: '2-digit',
                        year: 'numeric',
                      })}
                  </h6>
                </div>
                <h5 className="text-center mb-3">
                  Facture N°: {idFacture && idFacture.replaceAll('-', '/')}
                </h5>
              </Col>
              <Col
                sm="auto"
                className="ms-auto"
                style={{
                  textAlign: 'left',
                  minWidth: '400px',
                  border: '1px solid #000000',
                  borderRadius: '6px',
                  padding: '10px',
                  marginRight: '10px',
                }}
              >
                {facture && (
                  <>
                    <h5 className="d-flex align-items-center mb-2">
                      <FaUserTie className="me-2" /> Client : {facture[0].client}
                    </h5>
                    <h6 className="fs-10">
                      {' '}
                      <FaMapMarkerAlt className="me-2" />
                      Adresse : {facture[0].adresse}
                    </h6>
                    <h6 className="fs-10" style={{ color: '#000000' }}>
                      <div className="d-flex align-items-center mb-2">
                        <FaPhoneAlt className="me-2" />
                        Télephone : {facture[0].tel}
                      </div>
                      <div className="d-flex align-items-center">
                        <HiDocumentText className="me-2 " /> Matricule Fiscale :
                        {facture[0].matriculeFiscale}
                      </div>
                    </h6>
                  </>
                )}
              </Col>
            </Row>

            <div className="mt-4 fs-11">
              <SimpleBar>
                <Table border={1} striped className="border-bottom">
                  <thead data-bs-theme="light">
                    <tr className="bg-primary dark__bg-1000">
                      <th className="text-white border-0">Code produit</th>
                      <th className="text-white border-0">Produit</th>
                      <th className="text-white border-0 text-center">Quantité</th>
                      <th className="text-white border-0 text-end">PU HT</th>
                      <th className="text-white border-0 text-end">TVA</th>
                      <th className="text-white border-0 text-end">PROMO</th>
                      <th className="text-white border-0 text-end">PT TTC</th>
                    </tr>
                  </thead>
                  <tbody>
                    {details.map(detail => (
                      <tr key={detail.codeproduit + detail.nfact}>
                        <td className="align-middle text-center">{detail.codeproduit}</td>
                        <td className="align-middle fw-bold">{detail.produit}</td>
                        <td className="align-middle text-center">{detail.qte}</td>
                        <td className="align-middle text-end">
                          {(detail.puht / (1 + detail.tva / 100)).toFixed(3)}
                        </td>
                        <td className="align-middle text-end">{detail.tva} %</td>
                        <td className="align-middle text-end">{detail.promo} %</td>
                        <td className="align-middle text-end fw-bold">
                          {(detail.qte * detail.puht * (1 - detail.promo / 100)).toFixed(3)}
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </Table>
              </SimpleBar>
            </div>

            <Row className="justify-content-end mt-4">
              <Col xs="auto">
                <div className="d-flex">
                  {facture && (
                    <Table
                      border={1}
                      size="sm"
                      className="fs-10 text-end me-5"
                      style={{ height: '100px' }}
                    >
                      <tbody className="d-flex flex-column align-items-start">
                        <tr className="text-start">
                          <th className="text-900">TVA 7%:</th>
                          <td className="fw-semibold text-end">
                            {parseFloat(facture[0].tva6).toFixed(3)}
                          </td>
                        </tr>
                        <tr className="border-top text-start mt-2">
                          <th className="text-900">TVA 13%:</th>
                          <td className="fw-semibold text-end">
                            {parseFloat(facture[0].tva12).toFixed(3)}
                          </td>
                        </tr>
                        <tr className="border-top text-start">
                          <th className="text-900">TVA 19%:</th>
                          <td className="fw-semibold text-end">
                            {parseFloat(facture[0].tva18).toFixed(3)}
                          </td>
                        </tr>
                      </tbody>
                    </Table>
                  )}
                  {facture && (
                    <Table border={1} size="sm" className="fs-10 text-end">
                      <tbody>
                        <tr className="text-start">
                          <th className="text-900">Total HT AV REMISE:</th>
                          <td className="fw-semibold">
                            {parseFloat(facture[0].mntdtfin - facture[0].valremise).toFixed(3)}
                          </td>
                        </tr>
                        <tr className="border-top text-start">
                          <th className="text-900">REMISE:</th>
                          <td className="fw-semibold">
                            {parseFloat(facture[0].valremise).toFixed(3)}
                          </td>
                        </tr>
                        <tr className="border-top text-start fw-bolder">
                          <th className="text-900">Total HT AP REMISE:</th>
                          <td className="fw-bolder text-900">
                            {parseFloat(facture[0].mntdt).toFixed(3)}
                          </td>
                        </tr>
                        <tr className="border-top border-top-2 fw-bolder text-900 text-start">
                          <th className="text-900">TVA:</th>
                          <td className="text-900">{parseFloat(facture[0].valtva).toFixed(3)}</td>
                        </tr>
                        <tr className="border-top border-top-2 fw-bolder text-900 text-start">
                          <th className="text-900">TIMBRE:</th>
                          <td className="text-900">{parseFloat(facture[0].timbre).toFixed(3)}</td>
                        </tr>
                        <tr className="border-top border-top-2 fw-bolder text-900 bg-primary text-white text-start">
                          <th className="text-white">TOTAL TTC:</th>
                          <td className="text-white">
                            {parseFloat(facture[0].mntdtfin + facture[0].timbre).toFixed(3)}
                          </td>
                        </tr>
                      </tbody>
                    </Table>
                  )}
                </div>
              </Col>
            </Row>
          </Card.Body>
          <Card.Footer className="bg-body-tertiary">
            <p className="fs-10 mb-0">
              Arrété la présente Facture à la somme de: Quarante cinq dinars dix-sept millimes.
            </p>
          </Card.Footer>
        </Card>
      </div>
      <div style={{ position: 'absolute', top: '-9999px', left: '-9999px', visibility: 'hidden' }}>
        {magasinData && facture && details.length > 0 && (
          <div ref={printRef}>
            <PrintableInvoice
              idFacture={idFacture}
              magasinData={magasinData}
              facture={facture}
              details={details}
            />
          </div>
        )}
      </div>
    </>
  );
};

const PrintableInvoice = forwardRef(({ idFacture, magasinData, facture, details }, ref) => {
  if (!magasinData || !facture || !details.length) return null;

  return (
    <div ref={ref} style={{ padding: '20px' }}>
      <h2>Facture N° {idFacture.replaceAll('-', '/')}</h2>
      <p>Client: {facture[0].client}</p>
      <p>Adresse: {facture[0].adresse}</p>
      <p>Date: {facture[0].date.split('T')[0]}</p>
      <table style={{ width: '100%', borderCollapse: 'collapse' }} border="1">
        <thead>
          <tr>
            <th>Produit</th>
            <th>Quantité</th>
            <th>Prix TTC</th>
          </tr>
        </thead>
        <tbody>
          {details.map(detail => (
            <tr key={detail.codeproduit + detail.nfact}>
              <td>{detail.produit}</td>
              <td>{detail.qte}</td>
              <td>{(detail.qte * detail.puht * (1 - detail.promo / 100)).toFixed(3)}</td>
            </tr>
          ))}
        </tbody>
      </table>
      <p>Total TTC: {facture[0].mntdtfin}</p>
    </div>
  );
});

PrintableInvoice.displayName = 'PrintableInvoice';

export default Invoice;
